module.exports = __webpack_public_path__ + "img/icon_4_0.41143ffb.png";